import React from 'react';

import { FlexLayout as PrismUIFlexLayout } from '@nutanix-ui/prism-reactjs';
import type { FlexLayoutProps as PrismUIFlexLayoutProps } from '@nutanix-ui/prism-reactjs/lib/components/v2/Layouts/FlexLayout';

export type FlexLayoutProps = PrismUIFlexLayoutProps;

export default function FlexLayout(props: React.PropsWithChildren<FlexLayoutProps>) {
  return <PrismUIFlexLayout {...props} />;
}
